import React, { useEffect, useState } from 'react';
import { MessageCircle, X, Send, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FloatingMessageButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-32">
      {isVisible && <motion.div initial={{
      opacity: 0,
      scale: 0.5,
      y: 50
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.5,
      y: 50
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3" data-id="element-33">
          {/* Expanded panel */}
          <AnimatePresence data-id="element-34">
            {isOpen && <motion.div initial={{
          opacity: 0,
          y: 20,
          scale: 0.9
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.9
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 25
        }} className="bg-white rounded-2xl shadow-2xl border border-gray-200 w-80 overflow-hidden" data-id="element-35">
                {/* Header */}
                <div className="bg-[#C41E24] px-5 py-4 flex items-center justify-between" data-id="element-36">
                  <div className="flex items-center gap-3" data-id="element-37">
                    <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center" data-id="element-38">
                      <img src="https://cdn.magicpatterns.com/uploads/64Tmnvawd7bSgaucnVbdbX/d9a147a9-aeff-42e4-941e-cfb023a07271-Photoroom.png" alt="I&A Logo" className="w-8 h-8 object-contain brightness-0 invert" data-id="element-39" />
                    </div>
                    <div data-id="element-40">
                      <p className="text-white font-bold text-sm" data-id="element-41">
                        I&A Landscaping
                      </p>
                      <p className="text-white/80 text-xs" data-id="element-42">
                        We typically reply instantly
                      </p>
                    </div>
                  </div>
                  <button onClick={() => setIsOpen(false)} className="text-white/80 hover:text-white transition-colors" data-id="element-43">
                    <X size={20} data-id="element-44" />
                  </button>
                </div>

                {/* Body */}
                <div className="p-5 space-y-4" data-id="element-45">
                  <div className="bg-gray-100 rounded-xl rounded-tl-sm p-4 max-w-[85%]" data-id="element-46">
                    <p className="text-sm text-gray-800" data-id="element-47">
                      Hi there! Ready to transform your outdoor space? Call us
                      or send a message — we'd love to help!
                    </p>
                  </div>

                  <div className="space-y-3" data-id="element-48">
                    <a href="tel:4402221065" className="flex items-center justify-center gap-3 w-full bg-[#C41E24] hover:bg-[#a8181e] text-white py-3 px-4 rounded-xl font-semibold transition-colors shadow-md" data-id="element-49">
                      <Phone size={18} data-id="element-50" />
                      <span data-id="element-51">Call (440) 222-1065</span>
                    </a>
                    <a href="sms:4402221065" className="flex items-center justify-center gap-3 w-full bg-[#1B4332] hover:bg-[#2D6A4F] text-white py-3 px-4 rounded-xl font-semibold transition-colors shadow-md" data-id="element-52">
                      <Send size={18} data-id="element-53" />
                      <span data-id="element-54">Send a Text Message</span>
                    </a>
                  </div>

                  <p className="text-xs text-gray-400 text-center" data-id="element-55">
                    FREE Estimates — No Obligation
                  </p>
                </div>
              </motion.div>}
          </AnimatePresence>

          {/* FAB Button */}
          <motion.button onClick={() => setIsOpen(!isOpen)} whileHover={{
        scale: 1.1
      }} whileTap={{
        scale: 0.95
      }} className={`w-16 h-16 rounded-full shadow-2xl flex items-center justify-center transition-colors ${isOpen ? 'bg-gray-700 hover:bg-gray-800' : 'bg-[#C41E24] hover:bg-[#a8181e]'}`} data-id="element-56">
            <AnimatePresence mode="wait" data-id="element-57">
              {isOpen ? <motion.div key="close" initial={{
            rotate: -90,
            opacity: 0
          }} animate={{
            rotate: 0,
            opacity: 1
          }} exit={{
            rotate: 90,
            opacity: 0
          }} transition={{
            duration: 0.2
          }} data-id="element-58">
                  <X size={28} className="text-white" data-id="element-59" />
                </motion.div> : <motion.div key="message" initial={{
            rotate: 90,
            opacity: 0
          }} animate={{
            rotate: 0,
            opacity: 1
          }} exit={{
            rotate: -90,
            opacity: 0
          }} transition={{
            duration: 0.2
          }} data-id="element-60">
                  <MessageCircle size={28} className="text-white" data-id="element-61" />
                </motion.div>}
            </AnimatePresence>

            {/* Pulse ring */}
            {!isOpen && <span className="absolute inset-0 rounded-full bg-[#C41E24] animate-ping opacity-20" data-id="element-62"></span>}
          </motion.button>
        </motion.div>}
    </AnimatePresence>;
}